"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAreaWidget = void 0;
var tslib_1 = require("tslib");
var TableauUI = tslib_1.__importStar(require("@tableau/tableau-ui"));
var React = tslib_1.__importStar(require("react"));
var Declarative_1 = require("../utils/Declarative");
/** A drop-in replacement for a TEXTAREA element with standard styling, accessible label and validation messages, and focus indication. */
exports.TextAreaWidget = React.forwardRef(function (props, ref) {
    var testId = props.testId, textAreaProps = tslib_1.__rest(props, ["testId"]);
    return React.createElement(TableauUI.TextArea, tslib_1.__assign({ "data-tb-test-id": Declarative_1.makeTestId(testId, 'TextArea') }, textAreaProps, { ref: ref }));
});
exports.TextAreaWidget.displayName = 'TextAreaWidget';
//# sourceMappingURL=TextAreaWidget.js.map